<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${resellerService.name}` }} - {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="resellerService" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "reseller-service-view-logs",

  components: { LogListTable },

  props: ["resellerService"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
